const KEY = 'campfire-trivia.highscore';

/** Minimal storage surface so this is testable without a real localStorage. */
export interface KeyValueStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function defaultStore(): KeyValueStore | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null; // e.g. storage disabled in private mode
  }
}

export function getHighScore(store: KeyValueStore | null = defaultStore()): number {
  if (!store) return 0;
  const raw = store.getItem(KEY);
  const n = raw ? parseInt(raw, 10) : 0;
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** Persist the score if it beats the stored best. Returns the resulting best. */
export function recordScore(score: number, store: KeyValueStore | null = defaultStore()): number {
  const best = Math.max(score, getHighScore(store));
  if (store) store.setItem(KEY, String(best));
  return best;
}
